<script>
  import { usersStore } from "../store/Users.js";
  import { fade } from "svelte/transition";
  import { getContext } from "svelte";
  import Table from "../SharedComponents/Table.svelte";
  import Plus from "../Vectors/Plus.svelte";
  import UserDetail from "./UserDetail.svelte";
  import * as util from "../js/util.js";

  const { open } = getContext("modal");

  let userId = "";

  function AddUser() {
    open(UserDetail, {callback:()=>{userStore.getUsers()}});
  }

  function EditUser(user) {
    open(UserDetail, { user: $usersStore.users.find((u) => u.id == user.id) });
  }

  usersStore.getUsers();
  $: useUsers = $usersStore.users &&  $usersStore.users.map((u) => {
    return {
      id: u.id,
      columns: { Username: u.userName, FullName: u.FullName//Rollen: util.getCommaSepartedStringsAsNoBr(u.roles)
       },
    };
  });
</script>

<Table
  Title="Users"
  bind:Items={useUsers}
  AddRowCallBack={AddUser}
  RowClickCallBack={EditUser} />
